/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_EmptyInputs */

const cs_investor_empty = /** @type {(inputs: Investor_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investiční profil zatím není vyplněn.`)
};

const en_investor_empty = /** @type {(inputs: Investor_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No investor profile yet.`)
};

/**
* | output |
* | --- |
* | "No investor profile yet." |
*
* @param {Investor_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_empty = /** @type {((inputs?: Investor_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_empty(inputs)
	return cs_investor_empty(inputs)
});